import script from "./whDOnceImg3_t4A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg3_t4A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg3_t4A.vue?vue&type=style&index=0&id=0b51304d&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b51304d"]])

export default __exports__